module.exports = __webpack_public_path__ + "static/media/Cambay-Regular.8fb0abba.ttf";